// extracted by mini-css-extract-plugin
module.exports = {"footerContainer":"PrintFooter_footerContainer__31X0V"};